export const companyInfo = {
  name: 'Varde Gymnastikforening',
  address: 'Chr Richardts Vej 5',
  zipCity: '6800 Varde',
  email: 'gymnastikvarde@gmail.com',
  phone: '+45 61 69 37 04',
  facebook: 'https://www.facebook.com/VardeGymnastikforening/',
  seasonStart: 'August',
}

export const designTokens = {
  heroImage:
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/ad4b383f-6fe8-41f8-a893-785158914432.jpg',
  splitImage:
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/5627b5c9-3aeb-41c3-8593-03a95c4f72ba.png',
  homeSupportImage:
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/5d65b9bf-6404-47ee-831e-4de037767061.jpg',
  programImage:
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/70332d62-b86e-4249-85b4-37f0b773a477.jpg',
  galleryImages: [
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/9a718078-3d21-4008-ac69-ebdd3712c351.jpeg',
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/cfcb1cc6-6d9b-4e39-a669-8c43a40bf58d.jpeg',
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/a85d5531-0c13-448c-83e0-b22e769c409c.jpeg',
    'https://assets.auxodev.dk/assets/b6209d66-5898-40d7-bfd5-6255faf6b7d0/0647236c-c589-4142-be6f-6a2b6a2b383a.jpeg',
  ],
}

export const navigation = [
  {
    label: 'Gymnastik 26/27',
    href: '/gymnastik-26-27',
    children: [
      { label: 'Børnehold', href: '/gymnastik-26-27/bornehold' },
      { label: 'Dans/Spring', href: '/gymnastik-26-27/dans-spring' },
      { label: 'Voksenhold', href: '/gymnastik-26-27/voksenhold' },
      { label: 'Senior', href: '/gymnastik-26-27/senior' },
      { label: 'Special', href: '/gymnastik-26-27/special' },
      {
        label: 'Generelt',
        href: '/gymnastik-26-27',
        subItems: [
          { label: 'Adresse/find os', href: '/adresse-find-os' },
          { label: 'Opvisningstøj', href: '/opvisningstoej' },
          { label: 'Retningslinjer', href: '/retningslinjer' },
          { label: 'Oversigt hold', href: '/oversigt-hold' },
          { label: 'Pigelejr 2026', href: '/pigelejr-2026' },
        ],
      },
    ],
  },
  {
    label: 'Svømning 26/27',
    href: '/svomning-26-27',
    children: [
      { label: 'Børnehold', href: '/svomning-26-27/bornehold' },
      { label: 'Voksenhold', href: '/svomning-26-27/voksenhold' },
      {
        label: 'Generelt',
        href: '/svomning-26-27',
        subItems: [
          { label: 'Adresse', href: '/adresse' },
          { label: 'Retningslinjer i svømning', href: '/retningslinjer-i-svoemning' },
        ],
      },
    ],
  },
  {
    label: 'Om os',
    href: '/om-os',
    children: [
      { label: 'Vedtægter', href: '/vedtaegter' },
      { label: 'Børneattester', href: '/boerneattester' },
      { label: 'Årskalender', href: '/aarskalender' },
      { label: 'Tilskud', href: '/tilskud' },
      { label: 'Årets fighter', href: '/aarets-fighter' },
      { label: 'Årets træner', href: '/aarets-traener' },
    ],
  },
  { label: 'Bestyrelse', href: '/bestyrelse', children: [] },
  { label: 'Galleri', href: '/galleri', children: [] },
  { label: 'Kontakt', href: '/kontakt', children: [] },
  { label: 'Tilmelding', href: '/tilmelding', children: [] },
]

export const quickActions = [
  { label: 'Kontakt', href: '/kontakt' },
  { label: 'Tilmelding', href: '/tilmelding' },
  { label: 'Facebook', href: companyInfo.facebook, external: true },
]

export const overviewFilters = {
  'gymnastik-26-27': {
    'Børnehold': ['børnehold'],
    'Dans/Spring': ['dans', 'spring'],
    'Voksenhold': ['voksenhold'],
    'Senior': ['senior'],
    'Special': ['special'],
    'Generelt': [],
  },
  'gymnastik-25-26': {
    'Børnehold': ['børnehold'],
    'Dans/Spring': ['dans', 'spring'],
    'Voksenhold': ['voksenhold'],
    'Senior': ['senior'],
    'Special': ['special'],
    'Generelt': [],
  },
  'svomning-26-27': {
    'Børnehold': ['svømning'],
    'Voksenhold': ['svømning'],
    'Generelt': ['svømning'],
  },
  'svomning-25-26': {
    'Børnehold': ['svømning'],
    'Voksenhold': ['svømning'],
    'Generelt': ['svømning'],
  },
}

export const routeAliases = {
  '/': 'home',
  '/index': 'home',
  '/kontakt': 'kontakt',
  '/galleri': 'galleri',
  '/om-os': 'om-os',
  '/bestyrelse': 'bestyrelse',
  '/tilmelding': 'tilmelding',
  '/adresse': 'adresse',
  '/adresse-find-os': 'adressefind-os',
  '/soeg': 'soeg',
  '/gymnastik-26-27': 'gymnastik-26-27',
  '/gymnastik-25-26': 'gymnastik-25-26',
  '/svomning-26-27': 'svomning-26-27',
  '/svomning-25-26': 'svomning-25-26',
  '/nyheder-side': 'nyheder',
  '/nyheder': 'nyheder',
  '/category/nyheder': 'nyheder',
  '/category/nyheder/page/2': 'nyheder-page-2',
  '/nyheder-side/page/2': 'nyheder-page-2',
  '/pigelejr-2026': 'pigelejr-2026',
  '/retningslinjer-i-svoemning': 'retningslinjer-i-svoemning',
  '/oversigt-hold': 'oversigt-hold',
}
